import React from 'react';
import { components as Core } from '../../../../core';
import { css, spacing, StyleSheet } from '../../../../../styles';

/**
 * Renders a responsive grid of integration fields.
 *
 * @param {object} props
 * @param {Array<object>} props.fields
 * @param {object} props.integration
 * @param {boolean} props.isSingleColumn
 * @param {object} props.updatedData
 */
export const IntegrationDetailsFields = ({
    fields = [],
    integration,
    isSingleColumn = false,
    updatedData
}) => (
    <div className={css(isSingleColumn ? styles.singleColumnGrid : styles.fieldGrid)}>
        <Core.FieldsGenerator fields={fields} data={integration} updatedData={updatedData} />
    </div>
);

const styles = StyleSheet.create({
    fieldGrid: {
        '& > div': {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            columnGap: spacing.s3,
            alignItems: 'start'
        }
    },
    singleColumnGrid: {
        '& > div': {
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr)',
            alignItems: 'start'
        }
    }
});
